export const WEB_MAX_WIDTH = 1024;
export const WEB_SHEET_MAX_WIDTH = 640;
